<template>
    <div class="d-flex flex-wrap gap-y-3">
        <span class="d-block w-100 text-md text-arapawa font-weight-600">
            {{ $t('popup_reminder.unpaid_invoice.title') }}
        </span>
        <b-table-simple
            borderless
            fixed
            hover
            stacked="md"
            table-class="invoice__table text-arapawa text-md mb-0"
        >
            <b-thead>
                <b-tr class="p-0">
                    <b-th
                        v-for="(field, index) in fields"
                        :key="index"
                        :class="field.thClass"
                    >
                        <div :class="field.thContentClass">
                            {{ field.label }}
                        </div>
                    </b-th>
                </b-tr>
            </b-thead>
            <b-tbody>
                <b-tr
                    v-for="(item, index) in items"
                    :key="index"
                    :tabindex="index"
                    class="cursor-pointer"
                    @click="goToInvoiceDetail(item)"
                >
                    <b-td
                        :stacked-heading="$t('invoices.id')"
                        class="px-0 py-2 align-middle"
                    >
                        {{ item.incrementId }}
                    </b-td>
                    <b-td
                        :stacked-heading="$t('invoices.service')"
                        class="px-0 py-2 align-middle"
                    >
                        {{ item.typeList }}
                    </b-td>
                    <b-td
                        :stacked-heading="$t('invoices.amount')"
                        class="
                            pr-semi-3
                            pl-0
                            py-2
                            text-break
                            font-weight-600
                            align-middle
                        "
                    >
                        {{
                            $helpers.renderPrice(item.grandTotal, {
                                currency: currentCurrencyId,
                            })
                        }}
                    </b-td>
                    <b-td
                        :stacked-heading="$t('common.action')"
                        class="px-0 py-2"
                    >
                        <a
                            :class="isEnLocale ? 'max-w-85-px' : 'max-w-121-px'"
                            :href="generatePayNowUrl(item)"
                            class="
                                invoice__paynow
                                d-flex
                                justify-content-center
                                align-items-center
                                rounded-xl
                                px-3
                                py-0
                                ls-normal
                                text-xs
                                font-weight-600
                                text-cinnabar text-hover-white
                                border-1 border-cinnabar
                                bg-white bg-hover-cinnabar
                                h-30-px
                            "
                            rel="noopener"
                            target="_blank"
                            @click.stop
                        >
                            {{ $t('button.pay_now') }}
                        </a>
                    </b-td>
                </b-tr>
            </b-tbody>
        </b-table-simple>
    </div>
</template>

<script>
import { LOCALES } from '@/constants/config';
import { mapGetters } from 'vuex';

const DEFAULT_TH_CLASSES =
    'p-0 pb-2 mb-2 font-weight-400 text-md border-bottom-1 border-white-smoke-5';
export default {
    name: 'UnpaidInvoiceList',
    props: {
        items: {
            type: Array,
            required: true,
        },
    },
    computed: {
        ...mapGetters('website', ['currentCurrencyId']),
        isEnLocale() {
            return this.$i18n.locale === LOCALES.EN;
        },
        fields() {
            return [
                {
                    label: this.$t('invoices.id'),
                    thClass: 'p-0',
                    thContentClass: `${DEFAULT_TH_CLASSES} pr-2x`,
                },
                {
                    label: this.$t('invoices.service'),
                    thClass: 'p-0',
                    thContentClass: `${DEFAULT_TH_CLASSES} pr-2x`,
                },
                {
                    label: this.$t('invoices.amount'),
                    thClass: 'p-0',
                    thContentClass: `${DEFAULT_TH_CLASSES} pr-2x`,
                },
                {
                    label: this.$t('common.action'),
                    thClass: `p-0 ${this.isEnLocale ? 'w-85-px' : 'w-121-px'}`,
                    thContentClass: DEFAULT_TH_CLASSES,
                },
            ];
        },
    },
    methods: {
        goToInvoiceDetail(item) {
            const { href } = this.$router.resolve({
                name: 'invoices.detail',
                params: { id: item.id },
            });
            window.open(href, '_blank');
        },
        generatePayNowUrl(item) {
            const { href } = this.$router.resolve({
                name: 'invoices.payment',
                params: { id: item.id },
            });
            return href;
        },
    },
};
</script>

<style lang="scss" scoped>
@import 'UnpaidInvoiceList';
</style>
